var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCrypto = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1755 4.72225C14.1766 3.49445 11.6731 2.5 8.58832 2.5C5.50357 2.5 3.00224 3.49557 3 4.72225M3 4.72225C3 5.95004 5.50133 6.94449 8.58832 6.94449C11.6753 6.94449 14.1766 5.95004 14.1766 4.72225L14.1766 13.3445M3 4.72225V18.0556C3.00112 19.2834 5.50245 20.2779 8.58832 20.2779C10.0849 20.2779 11.4361 20.0412 12.4387 19.6601M3.00112 9.16672C3.00112 10.3945 5.50245 11.389 8.58944 11.389C11.6764 11.389 14.1778 10.3945 14.1778 9.16672M12.5057 15.1946C11.4976 15.5891 10.115 15.8335 8.58832 15.8335C5.50245 15.8335 3.00112 14.8391 3.00112 13.6113M20.5272 13.9646C22.4909 15.9169 22.4909 19.0836 20.5272 21.0358C18.5635 22.9881 15.3781 22.9881 13.4144 21.0358C11.4507 19.0836 11.4507 15.9169 13.4144 13.9646C15.3781 12.0124 18.5635 12.0124 20.5272 13.9646Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCrypto);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/crypto.50a402b441e82c9492d45d753ee520de.svg";